import actionCreatorFactory from 'typescript-fsa';

import { UserAuth } from './auth.reducer';
import reduxConfig from '@store/config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/auth');

export const login = actionCreator.async<{}, UserAuth>('LOGIN');
export const getCurrentUser = actionCreator.async<{}, UserAuth>('CURRENT_USER');
export const logout = actionCreator<{}>('LOGOUT');
